import {
  GET_CAR_VALUE_RANGE_DROPDOWN,
  GET_CAR_VALUE_RANGE_DROPDOWN_SUCCESS,
  GET_CAR_VALUE_RANGE_DROPDOWN_ERROR
} from '../actions/carValueRangeDropdown';

const initialState = {
  loading: false,
  error: null,
  carValueRangeOptions: []
};

export default function carValueRangeDropdown(state = initialState, action) {
  switch (action.type) {
    case GET_CAR_VALUE_RANGE_DROPDOWN:
      return {
        ...state,
        loading: true,
        error: null
      };
    case GET_CAR_VALUE_RANGE_DROPDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        carValueRangeOptions: action.payload
      };
    case GET_CAR_VALUE_RANGE_DROPDOWN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
}
